import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import * as moment from 'moment';
import { DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT, loaiTuyenSinhValue, objectLoaiTuyenSinh, trangThaiDotTuyenSinhValue, objectTrangThaiDotTuyenSinh } from '../../../../../utils/define';
import { parseDoiTuongMienGiam } from '../dotTuyenSinh/DoiTuongMienGiamFields';

const ChiTietLopDaoTaoLienTucModal = ({ isOpen, onClose, data, getDonViName, getChucDanhName }) => {
    if (!data) return null;

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined) return '';
        const actualValue = typeof value === 'string' && valueMap ? valueMap[value] : value;
        const found = objectEnum.find((item) => item.value === actualValue);
        return found ? found.label : '';
    };

    return (
        <Modal
            show={isOpen}
            onHide={onClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
            style={{ zIndex: '9999' }}
        >
            <Modal.Header closeButton>
                <Modal.Title className="text-primary font-weight-bold">Chi tiết Tuyển sinh Đào tạo liên tục</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
                <h5 className="text-info mb-3 border-bottom pb-2">Thông tin chung</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <p><strong>Tên khóa học:</strong> <span className="text-danger">{data.tenKhoaHoc}</span></p>
                        <p><strong>Loại tuyển sinh:</strong> <span className="badge badge-success">{getLabelFromEnum(data.loaiTuyenSinh, objectLoaiTuyenSinh, loaiTuyenSinhValue)}</span></p>
                        <p><strong>Số thông báo tuyển sinh:</strong> {data.soQuyetDinh}</p>
                        <p><strong>Chức danh:</strong> {getChucDanhName ? getChucDanhName(data.doiTuongIds) : ''}</p>
                        <p><strong>Trạng thái:</strong> <span className="badge badge-primary">{getLabelFromEnum(data.trangThaiDotTuyenSinh, objectTrangThaiDotTuyenSinh, trangThaiDotTuyenSinhValue)}</span></p>
                    </Col>
                    <Col md={6}>
                        <p><strong>Khoa đề xuất:</strong> {getDonViName ? getDonViName(data.khoaDeXuatId) : ''}</p>
                        <p><strong>Thời gian khóa học:</strong> {data.thoiGianKhoaHoc} tháng</p>
                        <p><strong>Số lượng học viên:</strong> {data.soLuongHocVien}</p>
                        <p><strong>Học phí:</strong> {data.hocPhi != null ? new Intl.NumberFormat('vi-VN').format(data.hocPhi) : '0'} VNĐ</p>
                        <p><strong>Đối tượng miễn giảm:</strong> {parseDoiTuongMienGiam(data.doiTuongMienGiam).map(x => x.tenDoiTuong).join(', ') || 'Không có'}</p>
                    </Col>
                </Row>

                <h5 className="text-info mb-3 border-bottom pb-2">Thời gian đào tạo & Nhận hồ sơ</h5>
                <Row className="mb-3">
                    <Col md={6}>
                        <p><strong>Ngày khai giảng:</strong> {data.ngayKhaiGiang ? moment(data.ngayKhaiGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày bế giảng:</strong> {data.ngayBeGiang ? moment(data.ngayBeGiang).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                    </Col>
                    <Col md={6}>
                        <p><strong>Ngày bắt đầu nhận hồ sơ:</strong> {data.ngayBatDauNhanHoSo ? moment(data.ngayBatDauNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                        <p><strong>Ngày kết thúc nhận hồ sơ:</strong> {data.ngayKetThucNhanHoSo ? moment(data.ngayKetThucNhanHoSo).format(DATE_TIME_REACT_TYPE_ONE_WITHOUT_HOUR_FORMAT) : ''}</p>
                    </Col>
                </Row>

                <h5 className="text-info mb-3 border-bottom pb-2">Nội dung chi tiết</h5>
                <div className="mb-3">
                    <strong>Mục đích khóa học:</strong>
                    <div 
                        className="p-3 bg-light rounded mt-2" 
                        dangerouslySetInnerHTML={{ __html: data.mucDichKhoaHoc || '<i>Chưa cập nhật</i>' }} 
                    />
                </div>
                <div className="mb-3">
                    <strong>Nội dung khóa học:</strong>
                    <div 
                        className="p-3 bg-light rounded mt-2" 
                        dangerouslySetInnerHTML={{ __html: data.noiDungKhoaHoc || '<i>Chưa cập nhật</i>' }} 
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Đóng
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ChiTietLopDaoTaoLienTucModal;
